import React from "react";

import PublicPageFrame from "../components/ui/PublicPageFrame";
import AuthContainer from "../features/auth/containers/AuthContainer";

const AuthPage: React.FC = () => {
  return (
    <PublicPageFrame>
      <AuthContainer />
    </PublicPageFrame>
  );
};

export default AuthPage;
